import angular from 'angular';

import callUsComponent from './callUs.component';
import movingComponent from './moving.component';

export default angular.module('fp:customerportal:shop:common:ui', [])
    .component('fpCallUs', callUsComponent)
    .component('fpMoving', movingComponent);
